import { render, staticRenderFns } from "./PayrollExpensesTabs.vue?vue&type=template&id=5a5ddfe6&scoped=true"
import script from "./PayrollExpensesTabs.vue?vue&type=script&lang=js"
export * from "./PayrollExpensesTabs.vue?vue&type=script&lang=js"
import style0 from "./PayrollExpensesTabs.vue?vue&type=style&index=0&id=5a5ddfe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5ddfe6",
  null
  
)

export default component.exports